import React from 'react';
import { X } from 'react-feather';
import { cx } from '../../../../../ui/components/cx';
import './Chip.scss';

interface ChipProps {
  children: React.ReactNode;
  /** Shows a remove (×) button when set. */
  onRemove?: () => void;
  /** Accessible name and tooltip for the remove button. */
  removeLabel?: string;
  tone?: 'primary' | 'neutral' | 'danger';
  className?: string;
}

/**
 * Small value chip (e.g. a time slot) with an optional remove button. Unlike Badge it is
 * not uppercase, so times and dates read naturally.
 */
const Chip: React.FC<ChipProps> = ({ children, onRemove, removeLabel = 'Remove', tone = 'primary', className }) => (
  <span className={cx('ds-chip', `ds-chip--${tone}`, className)}>
    <span className="ds-chip__label">{children}</span>
    {onRemove && (
      <button type="button" className="ds-chip__remove" onClick={onRemove} aria-label={removeLabel} title={removeLabel}>
        <X size={12} aria-hidden />
      </button>
    )}
  </span>
);

export default Chip;
